import React from "react";

import '../../styles/global/ButtonStyles.css';

const EneaCoachingProfesional = () => {
  return (
    <section className="section-container">
      <h2>EneaCoaching Profesional</h2>
      <h3>¿Te sientes perdido profesionalmente? Encuentra tu propósito con el EneaCoaching Profesional</h3>
      <p>
        A veces, todos pasamos por momentos en los que nos sentimos desconectados de nuestro verdadero propósito profesional. Sé lo que es eso y, por esto, te entiendo y te comprendo perfectamente. Si sientes que no estás donde deberías estar, que te falta claridad o motivación en tu carrera, el EneaCoaching Profesional puede ser el cambio que necesitas para redirigir tu camino.
      </p>

      <h3>¿Qué es EneaCoaching Profesional?</h3>
      <p>
        El EneaCoaching Profesional es un proceso único que integra el poder del Eneagrama, el Coaching Ontológico y el concepto de Ikigai para ayudarte a encontrar tu propósito profesional y tomar decisiones alineadas con tu ser más profundo. Juntas estas herramientas trabajarán contigo para transformar tu perspectiva, identificar tus motivaciones más auténticas y ayudarte a superar los bloqueos que te impiden avanzar.
      </p>

      <h3>¿Te reconoces en alguna de estas situaciones?</h3>
      <ul>
        <li>Sientes que no sabes qué dirección tomar en tu carrera.</li>
        <li>Estás atrapado en un trabajo que no te apasiona ni te motiva.</li>
        <li>No sabes cuál es tu verdadero propósito profesional o cómo encontrarlo.</li>
        <li>Te cuesta tomar decisiones importantes porque no estás claro sobre lo que realmente deseas.</li>
      </ul>

      <p>
        Si es así, EneaCoaching Profesional es para ti.
      </p>

      <h3>Lo que conseguirás con el Pack de 10 sesiones:</h3>
      <ul>
        <li>1. Autoconocimiento profundo: a través del Eneagrama, entenderás tu tipo de personalidad y cómo influye en tu manera de trabajar, tomar decisiones y relacionarte. Esto te ayudará a descubrir cuál es tu verdadero propósito y qué actividades realmente te llenan.</li>
        <li>2. Claridad sobre tu propósito profesional: el proceso de Ikigai te guiará a descubrir ese “para qué” profundo que te impulsa, combinando lo que amas hacer, en lo que eres bueno, lo que el mundo necesita y lo que puedes ofrecer. Así podrás tomar decisiones que estén alineadas con tus valores y tu misión personal.</li>
        <li>3. Cambio de perspectiva: durante el proceso de Coaching Ontológico, trabajaremos en tus creencias limitantes, esos bloqueos mentales y emocionales que te impiden avanzar, y te ayudaré a transformar tu forma de ver las cosas, para que puedas tomar decisiones más acertadas y alineadas con tu propósito.</li>
        <li>4. Empoderamiento y motivación: te acompañaré en cada paso para que te sientas seguro de ti mismo y puedas avanzar con confianza hacia tus nuevos objetivos, sabiendo que estás tomando el camino que realmente te representa.</li>
      </ul>

      <h3>¿Por qué elegir EneaCoaching Profesional?</h3>
      <ul>
        <li>Un enfoque integral: Trabajamos tu desarrollo profesional desde todas las perspectivas: emocional, mental y espiritual.</li>
        <li>Transformación profunda: no solo se trata de conseguir objetivos, sino de cambiar la manera en que vives tu vida profesional, alineándola con tus verdaderas pasiones y talentos.</li>
        <li>Métodos probados: el Eneagrama, el Coaching Ontológico y el Ikigai son herramientas poderosas y comprobadas que te ayudarán a lograr resultados duraderos.</li>
      </ul>

      <h3>Tu próximo paso:</h3>
      <p>
        El Pack de 10 sesiones de EneaCoaching Profesional es la inversión que te ayudará a dar un giro a tu carrera y encontrar el propósito que te motiva. Cada sesión está diseñada para ser un paso hacia el descubrimiento de tu verdadera pasión profesional y para empoderarte para tomar decisiones valientes y acertadas.
      </p>

      <h3><strong>¡No esperes más!</strong></h3>

      <button 
            className="btn-contacto"
            onClick={() => {
                window.open(
                "https://wa.me/34696667110?text=Hola. Quiero información sobre EneaCoaching Profesional.",
                "_blank"
                );
            }}
            >
            Reserva Ahora tu Pack de 10 Sesiones
            </button>
      
    </section>
  );
};

export default EneaCoachingProfesional;
